import { getModelOfDevicePlaying, getUid } from './api-utils';
import { IS_BROWSER } from './is-browser';
import pkg from '../../package.json';

// CMD API
export const COMPANY = process.env.COMPANY || '';
export const CMD_URL = process.env.CMD_URL || '';
export const CMD_BASE_URL = process.env.CMD_BASE_URL || '';

export const APP_VERSION = IS_BROWSER ? pkg.browser_version : pkg.samsung_tv_version;
export const MANUFACTURER = IS_BROWSER ? 'webtv' : 'smarttv';
export const MODEL = getModelOfDevicePlaying();

export const DEVICE_UID = getUid();

// NTVB API
export const NTVB_BASE_URL = process.env.NTVB_BASE_URL || '';
export const NTVB_AUTH_BASE_URL = process.env.NTVB_AUTH_BASE_URL || '';
export const NTVB_CLIENT_ID = process.env.NTVB_CLIENT_ID || '';
export const NTVB_CLIENT_SECRET = process.env.NTVB_CLIENT_SECRET || '';

// KMM
export const KMM_LOG_LEVEL = process.env.KMM_LOG_LEVEL || 'ALL';
